import React from 'react';

import styles from 'prototypes/securedCard/app.module.scss';
import { formatMoney } from 'prototypes/securedCard/formatMoney';
import { PAYCHECK_COUNT_PRESETS } from 'prototypes/securedCard/prototypeAssumptions';
import { PaycheckRow } from 'prototypes/securedCard/types';

interface PaycheckStackProps {
  paychecks: PaycheckRow[];
  count: number;
  onCount: (count: number) => void;
}

const PaycheckStack = ({ paychecks, count, onCount }: PaycheckStackProps) => (
  <div className={styles.stack}>
    <div className={styles.presets} role="group" aria-label="Paychecks deposited">
      {PAYCHECK_COUNT_PRESETS.map((preset) => (
        <button
          key={preset}
          type="button"
          className={count === preset ? `${styles.preset} ${styles.presetOn}` : styles.preset}
          aria-pressed={count === preset}
          onClick={() => onCount(preset)}
        >
          {preset === 1 ? '1 payday' : `${preset} paydays`}
        </button>
      ))}
    </div>
    <div className={styles.payList}>
      {paychecks.map((paycheck) => (
        <div key={paycheck.index} className={styles.payRow}>
          <div>
            <p className={styles.ledgerTitle}>Payday {paycheck.index}</p>
            <p className={styles.ledgerMeta}>{paycheck.dateLabel}</p>
          </div>
          <div className={styles.weekValues}>
            <p className={styles.amountIn}>+{formatMoney(paycheck.depositCents)}</p>
            <p className={styles.ledgerMeta}>{formatMoney(paycheck.availableCents)} on the card</p>
          </div>
        </div>
      ))}
    </div>
  </div>
);

export default PaycheckStack;
